import React, { ReactNode } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './index.less';

interface ISimpleTitleProps {
    /**
     * 标题文本
     */
    text: string;
    fontSize?: number;
}

export const SimpleTitle: React.FC<ISimpleTitleProps> = ({ text, fontSize = 16 }) => {
    const leftNode = (
        <span className="b-custom-title_text" style={{ fontSize }}>
            {text}
        </span>
    );
    return <CustomTitle leftNode={leftNode} rightNode={null} />;
};

interface ICustomTitleProps {
    /**
     * 左边的节点
     */
    leftNode: ReactNode;

    /**
     * 右边的节点
     */
    rightNode: ReactNode;
}

export const CustomTitle: React.FC<ICustomTitleProps> = ({ leftNode, rightNode }) => {
    return (
        <div className="b-custom-title">
            {leftNode}
            {rightNode}
        </div>
    );
};

interface IBackTitleProps {
    /**
     * 标题文本
     */
    text: string;

    /**
     * 点击返回回调
     */
    handleBackClick: () => void;
}

export const BackTitle: React.FC<IBackTitleProps> = ({ text, handleBackClick }) => {
    const leftNode = (
        <div
            className="b-custom-title_left back"
            onClick={() => {
                handleBackClick();
            }}
        >
            <IconFont fontSize={16} name="BackArrowBlack" color="var(--content-input)" />
            <span className="b-custom-title_text">{text}</span>
        </div>
    );

    return <CustomTitle leftNode={leftNode} rightNode={null} />;
};
